import { render, staticRenderFns } from "./ItineraryICEContent.vue?vue&type=template&id=3506e23a"
import script from "./ItineraryICEContent.vue?vue&type=script&lang=ts"
export * from "./ItineraryICEContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports